import CopyButton from './copyButton';

export default CopyButton;
